module.exports = __webpack_public_path__ + "static/media/music.b579e4cf.mp3";